// Trailing-edge debounce for the type-ahead fields on the create form.
//
// An agent types an account number while the customer reads it out; without this,
// a six-character query puts five requests in flight and the slowest one lands
// last. 200ms is below the threshold where a list feels laggy and above the gap
// between keystrokes of someone typing fast (SPEC.md §6).

import { useEffect, useState } from 'react';

export default function useDebouncedValue(value, delay = 200) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
